var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "bg-white md__card--holder" }, [
    _c("div", { staticClass: "card border-0" }, [
      _c(
        "div",
        {
          staticClass:
            "card-header bg-navy d-flex align-items-center justify-content-between",
        },
        [
          _c("div", {
            staticClass: "card-task-title text-white",
            attrs: { contenteditable: false },
            domProps: {
              innerHTML: _vm._s(
                "<small>" + "Change Owner for </small>" + _vm.editTitle
              ),
            },
            on: {
              keypress: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                $event.preventDefault()
                return _vm.onTitleChanged($event)
              },
              blur: function ($event) {
                return _vm.onTitleChanged($event)
              },
              focus: _vm._onTitleFocusClicked,
            },
          }),
          _c("span", { staticClass: "card-task-title brace" }, [_vm._v("{")]),
        ]
      ),
      _c("div", { staticClass: "card-body" }, [
        _vm.project.user_owner
          ? _c(
              "form",
              { staticClass: "hideBlockParent" },
              [
                _c("UserPicker", {
                  staticClass: "userpicker-sidebar",
                  attrs: {
                    multi: false,
                    title: "Current Owner",
                    role: "OWNER",
                    showSearch: false,
                  },
                  on: {
                    userSelected: _vm.handleSubmit,
                    userRemoved: _vm.handleSubmit,
                  },
                  model: {
                    value: _vm.project.current_owner,
                    callback: function ($$v) {
                      _vm.$set(_vm.project, "current_owner", $$v)
                    },
                    expression: "project.current_owner",
                  },
                }),
                _vm.project.user_owner && _vm.project.current_owner
                  ? _c("UserPicker", {
                      staticClass: "userpicker-sidebar",
                      attrs: {
                        multi: false,
                        title: "New Owner",
                        role: "OWNER",
                        showSelectedNames:
                          _vm.project.user_owner.user.id !=
                          _vm.project.current_owner.user.id,
                      },
                      on: {
                        userSelected: _vm.handleSubmit,
                        userRemoved: _vm.handleSubmit,
                      },
                      model: {
                        value: _vm.project.user_owner,
                        callback: function ($$v) {
                          _vm.$set(_vm.project, "user_owner", $$v)
                        },
                        expression: "project.user_owner",
                      },
                    })
                  : _vm._e(),
                _c("div", { staticClass: "row mt-4" }, [
                  _c(
                    "div",
                    { class: { "col-md-12": true } },
                    [
                      _c(
                        "base-button",
                        {
                          staticClass: "btn-block",
                          attrs: { type: "success" },
                          on: { click: _vm.handleSubmit },
                        },
                        [_vm._v(_vm._s(_vm.editId ? "Update" : "Create"))]
                      ),
                    ],
                    1
                  ),
                ]),
              ],
              1
            )
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }